














import Vue from "vue";

// vue components
import DeviceTreeAppPage from "@/components/DeviceTreeAppPage.vue";
import FiltersCard from "./FiltersCard.vue";
import InstallationsWorkloadTable from "./InstallationsWorkloadTable.vue";

// vuex
import { mapActions, mapMutations, mapState } from "vuex";
import { RootState } from "@/store";
import { InstallationsWorkloadState } from "@/store/modules/InstallationsWorkloadModule/state";
import * as a from "@/store/modules/InstallationsWorkloadModule/actions";
import * as m from "@/store/modules/InstallationsWorkloadModule/mutations";

//model
import { dataTableItemsPerPage, MODULE_COLORS } from "@/utility/Constants";
import { InstallationWorkload } from "@/model/data/workload/InstallationWorkload";
import { GetWorkloadReqData } from "@/model/communication/workload/GetWorkloadReqData";
import { DataTableOptions } from "@/model/communication/supportObjects/DataTableOptions";
import { DataOptions } from "vuetify";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";

export default Vue.extend({
    components: {
        DeviceTreeAppPage,
        FiltersCard,
        InstallationsWorkloadTable,
    },
    data() {
        return {
            MODULE_COLORS,
            dataTableItemsPerPage,
            deviceTreeSelectedObjectItems: [],
        };
    },
    computed: {
        ...mapState({
            installationsList: (state: RootState): InstallationWorkload[] => state.installationWorkload.installationsList,

            reqData: function (state: RootState): GetWorkloadReqData {
                return state.installationWorkload.reqData;
            },

            currencies: (state: RootState): string[] => state.installationWorkload.currencies,
        }),
    },
    watch: {
        deviceTreeSelectedObjectItems(newValue) {
            var newReqData: GetWorkloadReqData = new GetWorkloadReqData(this.reqData);

            newReqData.installationNames = null;
            newReqData.folderIds = null;
            if (newValue) {
                if (newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).length > 0)
                    newReqData.installationNames = newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Device).map((c) => c.id);
                if (newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Folder).length > 0)
                    newReqData.folderIds = newValue.filter((c) => c.type == DeviceTreeNodeTypeEnum.Folder).map((c) => c.id);
            }

            // ritorno alla prima pagina
            newReqData.offset = 0;
            this.$refs.mainTable.backToTheFirst();

            this[m.SET_REQUEST_DATA](newReqData);
        },
    },
    methods: {
        ...mapActions([a.ON_PAGE_LOAD, a.FETCH_INSTALLATIONS_WORKLOAD]),
        ...mapMutations([m.SET_REQUEST_DATA]),

        onSubmit(filters) {
            var newReqData: GetWorkloadReqData = new GetWorkloadReqData(this.reqData);
            newReqData.currency = filters.currency;
            newReqData.startDate = filters.startDate;
            newReqData.endDate = filters.endDate;
            newReqData.offset = 0;
            newReqData.queryLimit = this.dataTableItemsPerPage[0];
            newReqData.orderBy = [];
            newReqData.orderByDescending = [];
            this.$refs.mainTable.backToTheFirst();
            this[m.SET_REQUEST_DATA](newReqData);
        },
    },
    async mounted() {
        this.deviceTreeSelectedObjectItems = [];
        await this[a.ON_PAGE_LOAD]();
    },
});
